import('@/styles/global.scss')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from 'vue2-google-maps'
import config from '../config'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import Vue2Filters from 'vue2-filters'
import VModal from 'vue-js-modal'
import moment from 'vue-moment'
import SocialSharing from 'vue-social-sharing'
import store from './store'
import Axios from 'axios'
import VueLazyLoad from 'vue-lazyload'
import Default from '@/components/Layouts/Default'
import Search from '@/components/Layouts/Search'
import english from './language/english'
import japanese from './language/japanese'

Vue.component('default-layout', Default)
Vue.component('search-layout', Search)

library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueGoogleMaps, {
  load: {
    key: config.GOOGLE_MAP_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})
Vue.component('gmap-cluster', GmapCluster);

Vue.use(Vue2Filters)
Vue.use(ElementUI, { locale })

Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

Vue.use(moment);
Vue.use(SocialSharing);
Vue.use(VueLazyLoad)

Vue.config.productionTip = false

//config axios
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
//defind language
Vue.filter('language', function (value) {
  let language = store.state.general.language === 'english' ? english : japanese
  return language[value] 
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
